let store = {
  state: {
    equipmentFold: false
  },
  mutations: {
  },
  actions:{
    //切换折叠
    foldSwitch({state}, foldKey){
      state[foldKey] = !state[foldKey]
      localStorage.setItem(foldKey, state[foldKey])
    }
  },
  getters:{
  }
}

//初始化
Object.keys(store.state).forEach(foldKey => {
  let fold = localStorage.getItem(foldKey)
  if(fold == null) return
  store.state[foldKey] = fold == 'true'
})

export default {
  ...store
}